/* eslint-disable prettier/prettier */
import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import React from "react";
import ReactDOM from "react-dom";

import ModelerModalDueDate from "./modeler-modal-dueDate";
import ModelerModalGroupList from "./modeler-modal-group-list";
import ModelerModalUserList from "./modeler-modal-user-list";

function BuildGroupModal(itens, elementdom, saveGroup, element) {
  ReactDOM.render(
    <ModelerModalGroupList
      FormComponents={itens}
      saveGroup={saveGroup}
      element={element}
    />,
    elementdom,
  );
}

function BuildUserModal(itens, elementdom, saveUser, element) {
  ReactDOM.render(
    <ModelerModalUserList
      FormComponents={itens}
      saveUser={saveUser}
      element={element}
    />,
    elementdom,
  );
}

function BuildDueDateModal(itens, elementdom, saveDate, element, label) {
  ReactDOM.render(
    <ModelerModalDueDate
      FormComponents={itens}
      saveDate={saveDate}
      element={element}
      label={label}
    />,
    elementdom,
  );
}

export default function (group, element, translate, modeling) {
  const saveGroup = function (element, values) {
    const bo = getBusinessObject(element);
    if (values === null || values === undefined) return;
    const listgroup = Object.keys(values);
    let candidateGroups = "";
    for (let idx = 0; idx < listgroup.length; idx++) {
      if (values[listgroup[idx]] === true)
        candidateGroups += listgroup[idx] + ",";
    }
    candidateGroups =
      candidateGroups.length > 1
        ? candidateGroups.substr(0, candidateGroups.length - 1)
        : candidateGroups;
    bo.set("camunda:candidateGroups", candidateGroups);

    //document.getElementById("camunda-candidateGroups").value = candidateGroups;
    modeling.updateProperties(element, {});
  };

  const saveUser = function (element, values) {
    const bo = getBusinessObject(element);
    if (values === null || values === undefined) return;
    const listUser = Object.keys(values);
    let candidateUsers = "";
    for (let idx = 0; idx < listUser.length; idx++) {
      if (values[listUser[idx]] === true) candidateUsers += listUser[idx] + ",";
    }
    candidateUsers =
      candidateUsers.length > 1
        ? candidateUsers.substr(0, candidateUsers.length - 1)
        : candidateUsers;
    bo.set("camunda:candidateUsers", candidateUsers);

    //document.getElementById("camunda-candidateUsers").value = candidateUsers;
    modeling.updateProperties(element, {});
  };

  const saveAssignee = function (element, values) {
    const bo = getBusinessObject(element);
    if (values === null || values === undefined) return;
    const listUser = Object.keys(values);
    let assignee = "";
    for (let idx = 0; idx < listUser.length; idx++) {
      if (values[listUser[idx]] === true) assignee += listUser[idx] + ",";
    }
    assignee =
      assignee.length > 1 ? assignee.substr(0, assignee.length - 1) : assignee;
    bo.set("camunda:assignee", assignee);

    //document.getElementById("camunda-assignee").value = assignee;
    modeling.updateProperties(element, {});
  };

  const saveDueDate = function (element, values) {
    const bo = getBusinessObject(element);
    bo.set("camunda:dueDate", values);
    //document.getElementById("camunda-dueDate").value = values;
    modeling.updateProperties(element, {});
  };

  const savefollowUpDate = function (element, values) {
    const bo = getBusinessObject(element);
    bo.set("camunda:followUpDate", values);
    //document.getElementById("camunda-followUpDate").value = values;
    modeling.updateProperties(element, {});
  };

  if (is(element, "camunda:Assignable")) {
    // Assignee
    const assigneeEntry = {
      id: "assigneeModal",
      modelProperty: "assigneeModal",
      html:
        '<button class="add" ' +
        'id="users-list-button" ' +
        'data-action="listUsers">' +
        "<span>...</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      listUsers(element, values) {
        const bo = getBusinessObject(element);
        const assignee = bo.get("camunda:assignee");
        const Users = {};

        const itens = assignee ? assignee.split(",") : [];
        for (let idx = 0; idx < itens.length; idx++) {
          Users[itens[idx]] = true;
        }

        const modalUser = document.createElement("modalUser");
        BuildUserModal(Users, modalUser, saveAssignee, element);
      },
    };

    group.entries.push(assigneeEntry);

    // Assignee
    group.entries.push(
      entryFactory.textField(translate, {
        id: "assignee",
        label: translate("Assignee"),
        modelProperty: "assignee",
      }),
    );

    // Candidate Users
    const candidateUsersEntry = {
      id: "candidateUsersModal",
      modelProperty: "candidateUsersModal",
      html:
        '<button class="add" ' +
        'id="user-list-candidate" ' +
        'data-action="listUsers">' +
        "<span>...</span>" +
        "</button>",
      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      listUsers(element, values) {
        const bo = getBusinessObject(element);
        const candidateUsers = bo.get("camunda:candidateUsers");
        const Users = {};

        const itens = candidateUsers ? candidateUsers.split(",") : [];
        for (let idx = 0; idx < itens.length; idx++) {
          Users[itens[idx]] = true;
        }

        const modalUser = document.createElement("modalUser");
        BuildUserModal(Users, modalUser, saveUser, element);
      },
    };

    group.entries.push(candidateUsersEntry);

    // Candidate Users
    group.entries.push(
      entryFactory.textField(translate, {
        id: "candidateUsers",
        label: translate("Candidate Users"),
        modelProperty: "candidateUsers",
      }),
    );

    // Candidate Groups
    const candidateGroupsEntry = {
      id: "candidateGroupsModal",
      modelProperty: "candidateGroupsModal",
      html:
        '<button class="add" ' +
        'id="cam-candidateGroups" ' +
        'data-action="listGroups">' +
        "<span>...</span>" +
        "</button>",
      // eslint-disable-next-line no-empty-function
      get() {},
      // eslint-disable-next-line no-empty-function
      set() {},
      listGroups(element) {
        const bo = getBusinessObject(element);
        const candidateGroups = bo.get("camunda:candidateGroups");
        const groups = {};

        const itens = candidateGroups ? candidateGroups.split(",") : [];
        for (let idx = 0; idx < itens.length; idx++) {
          groups[itens[idx]] = true;
        }

        const modalGroup = document.createElement("modalGroup");
        BuildGroupModal(groups, modalGroup, saveGroup, element);
      },
    };

    group.entries.push(candidateGroupsEntry);

    // Candidate Groups
    group.entries.push(
      entryFactory.textField(translate, {
        id: "candidateGroups",
        label: translate("Candidate Groups"),
        modelProperty: "candidateGroups",
      }),
    );

    // Due Date
    const dueDateEntry = {
      id: "dueDateModal",
      modelProperty: "dueDateModal",
      html:
        '<button class="add" ' +
        'id="cam-dueDate-btn" ' +
        'data-action="dueDateModal">' +
        "<span>...</span>" +
        "</button>",
      get(element) {
        const bo = getBusinessObject(element);
        const dueDate = bo.get("camunda:dueDate");

        return {
          dueDate: dueDate || "",
        };
      },
      set(element, values) {
        const bo = getBusinessObject(element);
        return cmdHelper.updateBusinessObject(element, bo, {
          "camunda:dueDate": values.dueDate || undefined,
        });
      },
      dueDateModal(element) {
        const bo = getBusinessObject(element);
        const dueDateValue = bo.get("camunda:dueDate");
        const label = translate("Due Date");
        const modalGroup = document.createElement("modaldueDate");

        BuildDueDateModal(
          dueDateValue,
          modalGroup,
          saveDueDate,
          element,
          label,
        );
      },
    };

    group.entries.push(dueDateEntry);

    // Due Date
    group.entries.push(
      entryFactory.textField(translate, {
        id: "dueDate",
        // eslint-disable-next-line no-template-curly-in-string
        description: translate(
          "The due date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)",
        ),
        label: translate("Due Date"),
        modelProperty: "dueDate",
      }),
    );

    // follow UpDate
    const followUpDateEntry = {
      id: "followUpDateModal",
      modelProperty: "followUpDateModal",
      html:
        '<button class="add" ' +
        'id="cam-follow-upDate-btn" ' +
        'data-action="followUpDateModal">' +
        "<span>...</span>" +
        "</button>",
      get(element) {
        const bo = getBusinessObject(element);
        const followUpDate = bo.get("camunda:followUpDate");

        return {
          followUpDate: followUpDate || "",
        };
      },
      set(element, values) {
        const bo = getBusinessObject(element);
        return cmdHelper.updateBusinessObject(element, bo, {
          "camunda:followUpDate": values.followUpDate || undefined,
        });
      },
      followUpDateModal(element) {
        const bo = getBusinessObject(element);
        const followUpDateValue = bo.get("camunda:followUpDate");
        const label = translate("Follow Up Date");
        const modalGroup = document.createElement("followUpDate");

        BuildDueDateModal(
          followUpDateValue,
          modalGroup,
          savefollowUpDate,
          element,
          label,
        );
      },
    };

    group.entries.push(followUpDateEntry);

    // FollowUp Date
    group.entries.push(
      entryFactory.textField(translate, {
        id: "followUpDate",
        // eslint-disable-next-line no-template-curly-in-string
        description: translate(
          "The follow up date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)",
        ), // eslint-disable-line no-console
        label: translate("Follow Up Date"),
        modelProperty: "followUpDate",
      }),
    );

    // priority
    group.entries.push(
      entryFactory.textField(translate, {
        id: "priority",
        label: translate("Priority"),
        modelProperty: "priority",
      }),
    );
  }
}
